export default __webpack_public_path__ + "static/media/xopa_cloudxier1.860b12b4.png";